import type { OrderItemEditor } from "./types";

const normalizeText = (value: unknown): unknown => {
  if (typeof value !== "string") return value ?? null;
  const normalized = value.trim().toLocaleLowerCase();
  return normalized || null;
};

export const orderItemSignature = (item: OrderItemEditor): string =>
  JSON.stringify([
    normalizeText(item.product_code),
    normalizeText(item.product_name),
    normalizeText(item.origin_code),
    normalizeText(item.origin_name),
    normalizeText(item.shipper_code),
    normalizeText(item.shipper_name),
    normalizeText(item.grade),
    normalizeText(item.rank),
    normalizeText(item.order_unit),
    item.order_quantity ?? null,
    normalizeText(item.weight),
    normalizeText(item.package_type),
    item.quantity_per_package ?? null,
    item.proposed_price ?? null,
    normalizeText(item.notes),
    normalizeText(item.daily_note),
    normalizeText(item.weekly_note),
  ]);

export const findDuplicateOrderItemRows = (
  items: OrderItemEditor[],
): [number, number] | undefined => {
  const firstRowBySignature = new Map<string, number>();

  for (let index = 0; index < items.length; index += 1) {
    const row = index + 1;
    const signature = orderItemSignature(items[index]);
    const duplicateRow = firstRowBySignature.get(signature);
    if (duplicateRow !== undefined) return [duplicateRow, row];
    firstRowBySignature.set(signature, row);
  }

  return undefined;
};
